import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import {CustomButton, CustomInput} from '../../material-dashboard-pro-react/components/index';
import RenderDivOrEmpty from '../RenderDivOrEmpty/RenderDivOrEmpty';

import style from './style';

function DeleteEntityWithCustomButtonsModalWindow(props) {
  const {
    classes,
    text,
    confirmText,
    isConfirmManualInput,
    confirmManualInputProps,
  } = props;

  const dialogClasses = {
    paper: classes.modalWindow__paper,
    root: classes.modalWindow,
  };
  const dialogTitleClasses = {
    root: classes.modalWindow__titleRoot,
  };
  const dialogActionsClasses = {
    root: isConfirmManualInput
      ? classNames(classes.modalWindow__actions, classes.modalWindow__actionsWithInput)
      : classes.modalWindow__actions,
  };

  return (
    <Dialog
      open={true}
      onClose={props.cancel}
      classes={dialogClasses}
    >
      <DialogTitle classes={dialogTitleClasses}>
        <p
          className={classNames(
            classes.modalWindow__title,
            classes.modalWindow__title_deleteEntity,
          )}
        >
          {text}
        </p>
      </DialogTitle>
      <DialogActions classes={dialogActionsClasses}>
        <RenderDivOrEmpty isShow={!isConfirmManualInput}>
          <CustomButton
            customClasses="modalWindow__button"
            color="red"
            onClick={props.confirm}
          >
            {confirmText}
          </CustomButton>
        </RenderDivOrEmpty>
        <RenderDivOrEmpty isShow={isConfirmManualInput}>
          <CustomInput
            type="text"
            inputProps={{
              className: 'modalWindow__input',
              ...confirmManualInputProps,
            }}
          />
        </RenderDivOrEmpty>
        <CustomButton
          customClasses="modalWindow__button"
          color="red"
          onClick={props.cancel}
        >
          {I18n.t('modalWindow.customButtonCancel')}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}

DeleteEntityWithCustomButtonsModalWindow.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  isConfirmManualInput: PropTypes.bool,
  confirmManualInputProps: PropTypes.object,
};

DeleteEntityWithCustomButtonsModalWindow.defaultProps = {
  isConfirmManualInput: false,
  confirmManualInputProps: {},
};

export default withStyles(style)(DeleteEntityWithCustomButtonsModalWindow);
